import { render, staticRenderFns } from "./banner-title.vue?vue&type=template&id=fa059340&scoped=true&"
import script from "./banner-title.vue?vue&type=script&lang=js&"
export * from "./banner-title.vue?vue&type=script&lang=js&"
import style0 from "./banner-title.vue?vue&type=style&index=0&id=fa059340&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa059340",
  null
  
)

export default component.exports